import { render } from "./Tour.vue?vue&type=template&id=39b2a432"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__